import moment from 'moment';

export function formatStripeExpiryDate(date: Date | number | string) {
  // Stripe date is a Unix timestamp
  const SECONDS_TO_MILLISECONDS = 1000;

  if (typeof date === 'number') {
    date = date * SECONDS_TO_MILLISECONDS;
  }

  return moment(date).format('MMM DD, YYYY');
}
